export default "__VITE_ASSET__28e56eeb__"